export interface Parameters {
  url: string;
  timeout: number;
}

export const imageUrlToBlob = ({ url, timeout }: Parameters): Promise<string | ArrayBuffer> => {
  return new Promise(async (resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(`Request to ${url} has timed out!`);
    }, timeout);

    const response = await fetch(url);

    if (!response.ok || response.status >= 400) {
      clearTimeout(timeoutId);
      reject('Remote content cannot be reached!');
      return;
    }

    const blobData = await response.blob();

    if (!(blobData instanceof Blob)) {
      clearTimeout(timeoutId);
      reject('Returned data is not a blob!');
      return;
    }

    const reader = new FileReader();

    reader.readAsDataURL(blobData);
    reader.onerror = () => {
      clearTimeout(timeoutId);
      reject(reader.error);
      reader.abort();
    };
    reader.addEventListener(
      'load',
      function readerLoaded() {
        clearTimeout(timeoutId);

        if (this.result) {
          resolve(this.result);
        } else {
          reject('Could not read blob data from response!');
        }

        reader.removeEventListener('load', readerLoaded, false);
      },
      false,
    );
  });
};
